"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSliderBehavior = void 0;
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_slider_constants_1 = require("./bc-slider-constants");
var bc_slider_constants_2 = require("./bc-slider-constants");
var bc_slider_constants_3 = require("./bc-slider-constants");
var bc_slider_constants_4 = require("./bc-slider-constants");
var bc_slider_constants_5 = require("./bc-slider-constants");
var BcSliderBehavior = (function (_super) {
    __extends(BcSliderBehavior, _super);
    function BcSliderBehavior() {
        return _super.call(this) || this;
    }
    BcSliderBehavior.setUpAll = function () {
        var tabsElements = Array.from(document.querySelectorAll("input[class^='".concat(bc_slider_constants_2.GROUP_SLIDER_SUFIX, "']")));
        var elements = [];
        for (var _i = 0, tabsElements_1 = tabsElements; _i < tabsElements_1.length; _i++) {
            var value = tabsElements_1[_i];
            var bc = new BcSliderBehavior();
            bc.setElement(value);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcSliderBehavior.prototype.setElement = function (element) {
        this.isReady = false;
        this.mySelf = element;
        if (this.mySelf.tagName != bc_slider_constants_4.TAG_NAME_SLIDER_EXPECTED) {
            this.mySelf = this.mySelf.querySelector("input[class^='".concat(bc_slider_constants_2.GROUP_SLIDER_SUFIX, "']"));
        }
        this.thumb = this.mySelf.parentElement.querySelector("[class='".concat(bc_slider_constants_3.THUMB_SLIDER_CLASS, "']"));
        (0, helpers_1.addFocusable)(this.mySelf, null, null, [this.thumb]);
    };
    BcSliderBehavior.prototype.setValue = function (value) {
        var input = this.mySelf;
        input.value = value;
        this.updateInput();
    };
    BcSliderBehavior.prototype._setUp = function () {
        var _this = this;
        this.mySelf.addEventListener('input', function (evt) {
            _this.updateInput();
        });
        this.updateInput();
    };
    BcSliderBehavior.prototype.updateInput = function () {
        var left = this.mySelf;
        var inputMin = parseInt(this.mySelf.getAttribute('min'));
        var inputMax = parseInt(this.mySelf.getAttribute('max'));
        var inputVal = parseInt(this.mySelf.value);
        var unidad = (inputMax - inputMin);
        var total = (inputVal - inputMin) * bc_slider_constants_5.SLIDER_N100 / unidad;
        this.mySelf.style.setProperty('--value', total.toString());
        if (this.outputFunction) {
            this.outputFunction(total);
        }
        if (!this.thumb) {
            this.thumb = this.mySelf.parentElement.querySelector("[class='".concat(bc_slider_constants_3.THUMB_SLIDER_CLASS, "']"));
        }
        this.thumb.style.left =
            (parseInt(((total / bc_slider_constants_5.SLIDER_N100) * (left.offsetWidth - bc_slider_constants_1.SLIDER_N24)).toString()) + left.offsetLeft).toString() +
                'px';
    };
    return BcSliderBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSliderBehavior = BcSliderBehavior;
